import styled from "styled-components";

export const LabelStyled = styled.label`
  display: block;
  margin-bottom: 5px;
`;
